import { useCallback } from 'react'
import LocalCache from '../../backend/LocalCache'
import EventsEngine from '../../engines/EventsEngine'

export type QueryOptions = {
    queryKey: string
}

const useInvalidatePagination = (options: QueryOptions) => {
    const invalidate = useCallback(async () => {
        if (options.queryKey.includes('*')) {
            const keySuffix = options.queryKey.split('/*')[0]
            const allKey = LocalCache.getLike(keySuffix)
            const FirstPageKey = allKey.filter(x => x.key.includes('[FIRSTPAGE]'))
            if (FirstPageKey.length > 0) {
                for (let i = 0; i < FirstPageKey.length; i++) {
                    const toStale = FirstPageKey[i].key
                    LocalCache.setStale(toStale)
                    EventsEngine.publish('query-cache-stale', { queryKey: toStale })
                }
            }
            const keyToClear = allKey.filter(x => !x.key.includes('[FIRSTPAGE]'))

            for (let i = 0; i < keyToClear.length; i++) {
                const key = keyToClear[i].key
                LocalCache.delete(key)
            }
        }
    }, [options.queryKey])

    return invalidate
}

export default useInvalidatePagination
